import { useTheme } from "@/comn/hooks";
import { _TEST1234 } from "../../config/ApiConfig";

export const Logo = () => {
    const {
        theme: { isDark },
    } = useTheme();

    const SRCS = {
        tanesw: {
            logo: `${process.env.PUBLIC_URL}/imgs/tanesw_logo.webp`,
            light: `${process.env.PUBLIC_URL}/imgs/tanesw_title.webp`,
            dark: `${process.env.PUBLIC_URL}/imgs/tanesw_title_dark.webp`,
        },
        tancis: {
            logo: `${process.env.PUBLIC_URL}/imgs/tancis_logo.webp`,
            light: `${process.env.PUBLIC_URL}/imgs/tancis_title.webp`,
            dark: `${process.env.PUBLIC_URL}/imgs/tancis_title_dark.webp`,
        },
        tanoga: {
            logo: `${process.env.PUBLIC_URL}/imgs/tanoga_logo.webp`,
            light: `${process.env.PUBLIC_URL}/imgs/tanoga_title.webp`,
            dark: `${process.env.PUBLIC_URL}/imgs/tanoga_title_dark.webp`,
        },
    };

    const src = SRCS[_TEST1234.SYSTEM_GROUP_ORI as keyof typeof SRCS];
    const alt = process.env.REACT_APP_SYSTEM_GROUP_NAME;
    const name = process.env.REACT_APP_SYSTEM_GROUP_NAME;

    return (
        <a
            href={
                window.location.origin +
                (_TEST1234.SYSTEM_GROUP_ORI === "tanoga"
                    ? "/ptlo"
                    : _TEST1234.SYSTEM_GROUP_ORI === "tancis"
                    ? "/ptli"
                    : _TEST1234.SYSTEM_GROUP_ORI === "tanesw"
                    ? "/ptle"
                    : ""
                )
            }
        >
                            
        <div className="flex items-center gap-2 min-h-[60px]">
            <img src={src["logo"]} alt={alt} title={name} width={40} height={40} />
            <img
                loading={isDark === "true" ? "lazy" : undefined}
                src={src["light"]}
                alt={alt}
                title={name}
                hidden={isDark === "true"}
                width={120}
                height={35}
            />
            <img
                loading={isDark === "false" ? "lazy" : undefined}
                src={src["dark"]}
                alt={alt}
                title={name}
                hidden={isDark === "false"}
                width={120}
                height={35}
            />
        </div>
        </a>
    );
};
